import { toggleFullscreen } from 'optimizepress-ui/src/js/fullscreen';
import $ from 'jquery';

export default class Menus {
    constructor() {
        $('.ops-fullscreenBtn, .opui-fullscreen-btn')
            .on('click', (e) => {
                e.preventDefault();

                toggleFullscreen(OpsScriptData.ajax_url);
            })
        ;
    }
}
